import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34caa04a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/logo.png",
  alt: "Mudanzas Chiclana Antonio Crespo",
  class: "logo"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Pide Presupuesto")
const _hoisted_3 = { class: "navegacion hide-sm hide-xs hide-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_MegaMenu = _resolveComponent("MegaMenu")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!

  return (_openBlock(), _createBlock(_component_ion_header, {
    class: "ion-no-border",
    id: "header"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_toolbar, {
        color: "transparent",
        class: "header-item"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, {
            to: "/",
            slot: "start"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_ion_button, {
            slot: "end",
            class: "hide-md hide-md hide-xs",
            color: "primary",
            "router-link": "/presupuesto"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_label, null, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_menu_button, {
            slot: "end",
            color: "dark",
            class: "iconMenu hide-lg hide-xl",
            menu: "mainMenu"
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_MegaMenu, {
              class: "main-menu",
              model: _ctx.items,
              orientation: "horizontal"
            }, null, 8, ["model"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}